exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trip-form {\n  font-family: \"Inter\", sans-serif;\n  font-optical-sizing: auto;\n  font-style: normal;\n}\n.trip-form--apartment .trip-required {\n  display: none !important;\n}\n@media screen and (min-width: 992px) and (max-width: 1199.99px) {\n  .trip-form--apartment > div:nth-child(1) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .trip-form--apartment > div:nth-child(1) .trip-btn--search {\n    grid-area: 2/2/3/2;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .trip-form--apartment > div:nth-child(1) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}", ""]);

// exports
